import React from "react";
import Img from "./basic/Img";
import { useInView } from "react-intersection-observer";
import { fbSshareLink, lnSshareLink, twShareLink } from "../feature/core";

// let scrollFlag_share = true;

const Share = () => {
    const { ref, inView } = useInView({
        offset: 0,
        triggerOnce: true,
    });
    return (
        <>
            <div className="share">
                <div className={`${[inView && "share_anim"]} share-image`}>
                    <Img fileName={"share"} />
                </div>
                <div
                    ref={ref}
                    className={`${[inView && "share_anim"]} share-button-wrap`}
                >
                    {/* //twitter */}
                    <div className="share-button">
                        <a
                            href={twShareLink}
                            target="_blank"
                            rel="noopener noreferrer"
                            onClick={() => {
                                gtag("event", "click", {
                                    event_category: "footer",
                                    event_label: "share_twitter",
                                });
                            }}
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 60 60"
                                className="share-button-twitter"
                            >
                                <g id="SP_design">
                                    <g>
                                        <circle
                                            style={{ fill: "#1d8be0" }}
                                            cx="30"
                                            cy="30"
                                            r="30"
                                        />
                                        <path
                                            style={{ fill: "#fff" }}
                                            d="M24.51,45.82c13.3,0,20.58-11.02,20.58-20.58,0-.31,0-.62-.02-.93,1.41-1.02,2.64-2.29,3.61-3.74-1.3,.58-2.69,.96-4.15,1.14,1.49-.9,2.64-2.31,3.18-4-1.4,.83-2.94,1.43-4.59,1.76-1.32-1.41-3.2-2.28-5.28-2.28-3.99,0-7.23,3.24-7.23,7.23,0,.57,.06,1.12,.19,1.65-6.01-.3-11.34-3.18-14.91-7.56-.62,1.07-.98,2.31-.98,3.63,0,2.51,1.28,4.72,3.22,6.02-1.19-.04-2.3-.36-3.28-.9,0,.03,0,.06,0,.09,0,3.5,2.49,6.43,5.8,7.09-.61,.17-1.25,.25-1.91,.25-.47,0-.92-.05-1.36-.13,.92,2.87,3.59,4.96,6.76,5.02-2.48,1.94-5.59,3.1-8.98,3.1-.58,0-1.16-.03-1.73-.1,3.2,2.05,7,3.25,11.09,3.25"
                                        />
                                    </g>
                                </g>
                            </svg>
                        </a>
                    </div>
                    {/* //facebook */}
                    <div className="share-button">
                        <a
                            href={fbSshareLink}
                            target="_blank"
                            rel="noopener noreferrer"
                            onClick={() => {
                                gtag("event", "click", {
                                    event_category: "footer",
                                    event_label: "share_facebook",
                                });
                            }}
                        >
                            <div className="share-bg-facebook">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 60 60"
                                    className="share-button-twitter"
                                >
                                    <g id="SP_design">
                                        <g>
                                            <path
                                                style={{ fill: "#1877e2" }}
                                                d="M60,30C60,13.43,46.57,0,30,0S0,13.43,0,30c0,14.97,10.97,27.38,25.31,29.64v-20.96h-7.62v-8.67h7.62v-6.61c0-7.52,4.48-11.67,11.33-11.67,3.28,0,6.72,.59,6.72,.59v7.38h-3.78c-3.73,0-4.89,2.31-4.89,4.68v5.63h8.32l-1.33,8.67h-6.99v20.96c14.34-2.25,25.31-14.66,25.31-29.64Z"
                                            />
                                            <path
                                                style={{ fill: "#fff" }}
                                                d="M41.68,38.67l1.33-8.67h-8.32v-5.63c0-2.37,1.16-4.68,4.89-4.68h3.78v-7.38s-3.43-.59-6.72-.59c-6.85,0-11.33,4.15-11.33,11.67v6.61h-7.62v8.67h7.62v20.96c1.53,.24,3.09,.36,4.69,.36s3.16-.12,4.69-.36v-20.96h6.99Z"
                                            />
                                        </g>
                                    </g>
                                </svg>
                            </div>
                        </a>
                    </div>
                    {/* //line */}
                    <div className="share-button">
                        <a
                            href={lnSshareLink}
                            target="_blank"
                            rel="noopener noreferrer"
                            onClick={() => {
                                gtag("event", "click", {
                                    event_category: "footer",
                                    event_label: "share_line",
                                });
                            }}
                        >
                            <div className="share-bg-line">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 60 60"
                                    className="share-button-twitter"
                                >
                                    <g id="SP_design">
                                        <g>
                                            <circle
                                                style={{ fill: "#00af73" }}
                                                cx="30"
                                                cy="30"
                                                r="30"
                                            />
                                            <g>
                                                <path
                                                    style={{ fill: "#fff" }}
                                                    d="M50.01,28.25c0-8.96-8.98-16.25-20.03-16.25S9.95,19.29,9.95,28.25c0,8.03,7.12,14.76,16.75,16.03,.65,.14,1.54,.43,1.76,.99,.2,.51,.13,1.3,.06,1.81,0,0-.23,1.41-.29,1.71-.09,.51-.4,1.98,1.73,1.08,2.14-.9,11.53-6.79,15.74-11.63h0c2.9-3.18,4.29-6.41,4.29-10Z"
                                                />
                                                <g>
                                                    <path
                                                        style={{
                                                            fill: "#00af73",
                                                        }}
                                                        d="M43.34,33.43c.21,0,.38-.17,.38-.38v-1.42c0-.21-.17-.38-.38-.38h-3.82v-1.47h3.82c.21,0,.38-.17,.38-.38v-1.42c0-.21-.17-.38-.38-.38h-3.82v-1.47h3.82c.21,0,.38-.17,.38-.38v-1.42c0-.21-.17-.38-.38-.38h-5.63c-.21,0-.38,.17-.38,.38h0v8.73h0c0,.22,.17,.39,.38,.39h5.63Z"
                                                    />
                                                    <path
                                                        style={{
                                                            fill: "#00af73",
                                                        }}
                                                        d="M22.53,33.43c.21,0,.38-.17,.38-.38v-1.42c0-.21-.17-.38-.38-.38h-3.82v-6.94c0-.21-.17-.38-.38-.38h-1.42c-.21,0-.38,.17-.38,.38v8.73h0c0,.22,.17,.39,.38,.39h5.63Z"
                                                    />
                                                    <rect
                                                        style={{
                                                            fill: "#00af73",
                                                        }}
                                                        x="24.12"
                                                        y="23.92"
                                                        width="2.19"
                                                        height="9.51"
                                                        rx=".38"
                                                        ry=".38"
                                                    />
                                                    <path
                                                        style={{
                                                            fill: "#00af73",
                                                        }}
                                                        d="M35.59,23.92h-1.42c-.21,0-.38,.17-.38,.38v5.19l-4-5.4s-.02-.03-.03-.04c0,0,0,0,0,0,0,0-.01-.02-.02-.02,0,0,0,0,0,0,0,0-.01-.01-.02-.02,0,0,0,0-.01,0,0,0-.01,0-.02-.01,0,0,0,0-.01,0,0,0-.01,0-.02-.01,0,0,0,0-.01,0,0,0-.01,0-.02,0,0,0,0,0-.01,0,0,0-.02,0-.02,0,0,0,0,0-.01,0,0,0-.02,0-.02,0,0,0-.01,0-.02,0,0,0-.01,0-.02,0,0,0-.01,0-.02,0,0,0,0,0-.01,0h-1.41c-.21,0-.38,.17-.38,.38v8.74c0,.21,.17,.38,.38,.38h1.42c.21,0,.38-.17,.38-.38v-5.19l4,5.41s.06,.07,.1,.1c0,0,0,0,0,0,0,0,.02,.01,.02,.01,0,0,0,0,.01,0,0,0,.01,0,.02,0,0,0,.01,0,.02,0,0,0,0,0,.01,0,0,0,.02,0,.03,0,0,0,0,0,0,0,.03,0,.07,.01,.1,.01h1.41c.21,0,.38-.17,.38-.38v-8.74c0-.21-.17-.38-.38-.38Z"
                                                    />
                                                </g>
                                            </g>
                                        </g>
                                    </g>
                                </svg>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Share;
